<template>
  <!-- Acciones flotantes arriba-derecha: guardar, capturar,
       atrás e información. Conserva los id/emits/data-action que ya existían en
       footer (save) y header (screenshot, back). -->
  <div class="epc-actions">
    <!-- Guardar: solo en modo diseño y si está permitido -->
    <b-tooltip v-if="designMode && _Allowed('save')" :label="$t('save')" position="is-bottom">
      <div id="toolbar-saveTools" class="epc-action-btn" @click="$emit('epc-click-save')">
        <b-icon pack="fas" icon="save"></b-icon>
      </div>
    </b-tooltip>

    <!-- Capturar pantalla: solo fuera de modo diseño -->
    <b-tooltip v-if="!designMode && _Allowed('show_screenshot')" :label="$t('screenshot')" position="is-bottom">
      <div class="epc-action-btn" data-action="screenshot" @click="$emit('epc-click-screenshot')">
        <b-icon pack="fas" icon="camera"></b-icon>
      </div>
    </b-tooltip>

    <!-- Atrás -->
    <b-tooltip v-if="_Allowed('show_back')" :label="$t('back')" position="is-bottom">
      <div class="epc-action-btn" data-action="back" @click="$emit('epc-click-return')">
        <b-icon pack="fas" icon="rotate-left"></b-icon>
      </div>
    </b-tooltip>

    <!-- Panel lateral derecho (abre/cierra el sidebar). Oculto si está fijado (acoplado):
         ahí el panel se gestiona con su propia chincheta/cerrar. -->
    <b-tooltip v-if="!sidebarPinned && _Allowed('show_side_panel')" :label="$t('side_panel')" position="is-bottom">
      <div class="epc-action-btn" :class="{ 'is-active': sidebarOpen }"
        data-action="toggle-sidebar" role="button" :aria-label="$t('side_panel')"
        @click="$emit('epc-toggle-sidebar')">
        <svg class="epc-panel-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
          aria-hidden="true" focusable="false" role="img">
          <path fill="none" d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
          <path fill="none" d="M15 4l0 16"></path>
        </svg>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "ViewerActionsDesign",

  props: {
    designMode: { type: Boolean, default: false },
    canActions: { type: Object, default() { return {} } },
    sidebarOpen: { type: Boolean, default: false },
    sidebarPinned: { type: Boolean, default: false },
  },

  methods: {
    _Allowed(action) {
      if (this.canActions[action] === undefined) return true;
      return !!this.canActions[action];
    },
  },
}
</script>

<style scoped>
.epc-actions {
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  z-index: 6;
}

.epc-action-btn {
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #343a40;
}

.epc-action-btn:hover {
  background-color: #f4f4f6;
  color: #3a6bc8;
}

.epc-action-btn.is-active {
  background-color: #efeffb;
  border-color: #d9d9f5;
  color: #6965db;
}

.epc-panel-icon {
  width: 17px;
  height: 17px;
}

/* El icono es de contorno: forzamos sin relleno por si alguna regla global
   rellena los <path> (pisaría el atributo fill="none"). */
.epc-panel-icon,
.epc-panel-icon path {
  fill: none;
}
</style>
